export var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["And"] = "and";
    LogicalOperator["Or"] = "or";
})(LogicalOperator || (LogicalOperator = {}));
